export const INCORRECT_ANSWER_OPTIONS = [
    { id: 'incorrectRightAnswer' },
    { id: 'obviousAnswers' },
    { id: 'sameQuestion' },
    { id: 'wrongCategory' },
    { id: 'incorrectQuestionText' },
];
